import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import styled from 'styled-components';
import { Button, ButtonProps } from '../button/button';
import { FontAwesomeIcon } from '../icon/icon';
import { CenterAlignedBox } from '../layout/layout';

const TriggerButton = styled(Button).attrs({
  type: 'text',
})`
  padding: 0 var(--spacing-03);
`;
const ButtonLabel = styled(CenterAlignedBox)``;

const getIconSize = (size: ButtonProps['size']) => {
  if (size === 'small') {
    return 12;
  }

  if (size === 'large') {
    return 20;
  }

  return 16;
};

interface Props extends ButtonProps {
  dropdownIndicator?: React.ReactNode;
}
export const DropdownTriggerButton: FC<Props> = ({
  children,
  size = 'small',
  dropdownIndicator = (
    <FontAwesomeIcon icon={faChevronDown} size={getIconSize(size)} />
  ),
  icon,
  ...props
}) => {
  return (
    <TriggerButton {...props} size={size}>
      <ButtonLabel>
        {icon}
        {children}
        {dropdownIndicator}
      </ButtonLabel>
    </TriggerButton>
  );
};
